
/**
* 1. 先判断是否已抽奖，若已抽奖直接调整至中奖结果页面
* 2.
*/
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

import CompanySearch from './components/CompanySearch'

export default {
components: { Group, XInput, Radio, Checker, CheckerItem, XButton, Selector, CompanySearch },
data () {
return {
openid: '',
lotteryProjectCode: '',
address: '',
userInfo: {
id: '',
union_id: '',
open_id: '',
user_type: '',
company_name: '',
contact_name: '',
phone: '',
position: '',
goodsNum: '',
countrys: [],
business: [],
scale: '',
create_time: '',
update_time: ''
},
countryList: ['北美', '欧洲', '澳洲', '东南亚', '俄罗斯', '其它'],
businessList: ['国内拖车报关行', '清关行', '海外仓', '国外车队', '货代'],
scaleList: ['0-30', '30-100', '100-300', '300-500', '500+']
}
},
async created () {
const p = new URLSearchParams(location.search)
this.openid = p.get('openid') || ''
await this.getUserInfo()
this.userInfo.user_type = p.get('type') || ''
this.lotteryProjectCode = p.get('lotteryProjectCode') || ''
this.address = p.get('address') || ''
},
methods: {
async submit () {
let that = this;

let errorList = [];
Object.keys(this.$refs).forEach(refName => {
const refElement = this.$refs[refName];
if (!refElement) return;
switch (refName) {
case 'business':

if (refElement.value.length <= 0) {
errorList.push('所属行业：' + '至少选择一个');
}
break;
case 'countrys':

if (refElement.value.length <= 0) {
errorList.push('出口国家：' + '至少选择一个');
}
break;
default:
if (refElement.required === true && that.$Utils.IsEmpty(refElement.value)) {
errorList.push(refElement.title + '：必填');
}
break;
}
});
if (errorList.length > 0) {
that.$Msgbox.alert(errorList.join('<br>'))
return;
}
let _userInfo = {...that.userInfo};

_userInfo.countrys = (_userInfo.countrys && _userInfo.countrys.length > 0) ? _userInfo.countrys.join(',') : '';
_userInfo.business = (_userInfo.business && _userInfo.business.length > 0) ? _userInfo.business.join(',') : '';

if (that.$Utils.IsEmpty(_userInfo.open_id)) {
_userInfo.open_id = that.openid;
}
const res = await that.$axios.post('/lottery/userinfo/submitLotteryUserInfo', null, {data: _userInfo})
if (res.meta.success) {
this.$router.push({
path: '/wx/lottery/lottery',
query: {
openid: this.openid,
userId: res.data.id,
userType: res.data.user_type,
lotteryProjectCode: this.lotteryProjectCode,
address: this.address
}
})
} else {
that.$Msgbox.alert(res.meta.message)
}
},

/*
获取当前用户信息
*/
async getUserInfo () {
let that = this;
const res = await that.$axios.post('/lottery/userinfo/getLotteryUserInfoByOpenId', null, {params: {openId: that.openid}})
if (res.meta.success) {
if (res.data && res.data.id) {
that.userInfo = res.data;
if (!that.$Utils.IsEmpty(that.userInfo.business)) {
that.userInfo.business = that.userInfo.business.split(',');
}
if (!that.$Utils.IsEmpty(that.userInfo.countrys)) {
that.userInfo.countrys = that.userInfo.countrys.split(',');
}
}
} else {
that.$Msgbox.alert(res.meta.message)
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/lottery/Info.vue